<template>
    <div >
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Replaced QR Code</li>
		</ol>

        <h1 class="page-header">Replaced QR Code</h1>
        <hr>

        <panel class="border border-secondary" style="margin : 0 10px" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <!-- <div class="col-lg-3 col-xs-12 " style="padding-left:0" >
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Status</label>
                        <div class="col-sm-9">
                            <select class="form-control" style="width:100%" v-model="filter.status">
                                <option value="" selected>All Status</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Month </label>
                        <select class="form-control w-75" v-model="filter.month">
                            <option v-for="(month, index) in monthList" :value="index">{{month}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Year</label>
                        <select class="form-control w-75" v-model="filter.year">
                            <option v-for="year in yearList">{{year}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-4 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="getData()" value="Search"></input>
                </div>
            </div>
        </panel>

        <div class=" row  w-100"  style="height:500px" v-if="data">
            <div class="col-xs-12 col-sm-4 mt-4 h-100">
                <div class="border border-secondary rounded  shadow paddingAllSide h-20">
                    <h3 style="font-weight:normal">Total Replaced QR Code :</h3>
                    <h3 class="text-right">{{data.total}}</h3>
                </div>
                <div class="mt-4 rounded border border-secondary shadow h-75">
                    <vehicleTypeTable :datas="data.vehicle_type"></vehicleTypeTable>
                </div>
            </div>
            <div class="col-xs-12 col-sm-8 mt-4" style="min-height:500px;"> 
                <pieChartLocation :datas="data.location" class="border border-secondary rounded shadow h-100 p-3"></pieChartLocation>
            </div>
        </div>

        <div class="w-100 row mt-4" v-if="data">
            <div class="col-xs-12 col-md-6 mt-4">
                <barGraphVehicleType :datas="data.vehicle_type" class="border border-secondary rounded shadow" style="min-height:500px"></barGraphVehicleType>
            </div>
            <div class="col-xs-12 col-md-6 mt-4" >
                <pieChartReplaceReason :datas="data.replaced_reason" class="border border-secondary rounded shadow" style="min-height:500px"></pieChartReplaceReason>
            </div>
        </div>
    </div>
</template>

<script>
import vehicleTypeTable from './childComponents/vehicleTypeTable';
import pieChartLocation from './childComponents/charts/pieChartLocation';
import pieChartReplaceReason from './childComponents/charts/pieChartReplaceReason';
import barGraphVehicleType from './childComponents/charts/barGraphVehicleType';

export default {
    data(){

        var filter = {
            month : new Date().getMonth(),
            year : new Date().getFullYear(),
        }

        let filterTable = JSON.parse(JSON.stringify(filter))
        let yearList = [];
        let yearNow = new Date().getFullYear();

        for(var i = 0 ; i < 10 ; i++){
            yearList.push(yearNow - i);
        }
        return {
            yearList : yearList,
            monthList : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
            data : null,
            filter : filter
        }
    },
    components : {
        vehicleTypeTable,
        pieChartLocation,
        pieChartReplaceReason,
        barGraphVehicleType
    },
    mounted(){
        this.getData();
    }, 
    methods : {
        getData(){
            this.data = null;
            let url = "/api/dashboard/replaced-qr?month="+ this.filter.month +"&year=" + this.filter.year;

            this.$http.get(url)
            .then((resp)=>{
                let data = resp.data.data;

                this.data = data;
                console.log(data)
            })
            .then(()=>{
                this.$store.state.updateData;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
    }
}
</script>

<style scoped>
    .h-20{
        height : 20%;
    }
    .paddingAllSide{
        padding : 15px;
    }
    .row{
        padding : 0
    }
</style>
